import vue from 'vue'
import vuex, { Store } from 'vuex'
import createPersistedState from "vuex-persistedstate"

vue.use(vuex)

const state = { //数据仓库
    printNoticeDetail: {
        printNoticeDetailType: '类型',
        printNoticeDetailTitle: '标题',
        
    },
    wifiFirstHintState: true,
    userData:'',
}

const mutations = {
    mutationsPrintNoticeDetail(state, datas) {
        return state.printNoticeDetail = datas
    },
    mutationsWifiFirstHintState(state, datas) {
        return state.wifiFirstHintState = datas
    },
    mutationsUserData(state, datas){
        return state.userData = datas
    }
}

const actions = {
    actionsPrintNoticeDetail(context, datas) {
        return context.commit('mutationsPrintNoticeDetail', datas)
    },
    actionsWifiFirstHintState(context, datas) {
        return context.commit('mutationsWifiFirstHintState', datas)
    },
    actionsUserData(context, datas) {
        return context.commit('mutationsUserData', datas)
    },
}

const getters = {
    getterPrintNoticeDetail(state) {
        return state.printNoticeDetail
    },
    getterWifiFirstHintState(state) {
        return state.wifiFirstHintState
    },
    getterUserData(state) {
        return state.userData
    },
}

const store = new vuex.Store({
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })],
    state,
    mutations,
    actions,
    getters
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/index.js